import {
  student1Svg,
  student2Svg,
  student3Svg,
  student4Svg,
  student5Svg,
  student6Svg,
  student7Svg,
  student8Svg,
  student9Svg,
  student10Svg,
  student11Svg,
  student12Svg,
  student13Svg,
  student14Svg,
  student15Svg,
  student16Svg,
  student17Svg,
  student18Svg,
  student19Svg,
  student20Svg,
  student21Svg,
  student22Svg,
  student23Svg,
  student24Svg,
  student25Svg
} from "@euka-mfes/bark";

export interface StudentAvatarOption {
  id: number;
  name: string;
  image: string;
  alt: string;
}

export const STUDENT_AVATAR_OPTIONS: StudentAvatarOption[] = [
  {
    id: 1,
    name: "Koda Kangaroo",
    image: student1Svg,
    alt: "Avatar image for Koda Kangaroo"
  },
  {
    id: 7,
    name: "Mo Monkey",
    image: student7Svg,
    alt: "Avatar image for Mo Monkey"
  },
  {
    id: 2,
    name: "Jani Joey",
    image: student2Svg,
    alt: "Avatar image for Jani Joey"
  },
  {
    id: 3,
    name: "Dani Duck",
    image: student3Svg,
    alt: "Avatar image for Dani Duck"
  },
  {
    id: 4,
    name: "Sami Sheep",
    image: student4Svg,
    alt: "Avatar image for Sami Sheep"
  },
  {
    id: 5,
    name: "Riki Rhino",
    image: student5Svg,
    alt: "Avatar image for Riki Rhino"
  },
  {
    id: 8,
    name: "Mavi Mouse",
    image: student8Svg,
    alt: "Avatar image for Mavi Mouse"
  },
  {
    id: 9,
    name: "Pike Penguin",
    image: student9Svg,
    alt: "Avatar image for Pike Penguin"
  },
  {
    id: 10,
    name: "Poko Pig",
    image: student10Svg,
    alt: "Avatar image for Poko Pig"
  },
  {
    id: 6,
    name: "Kidd Cat",
    image: student6Svg,
    alt: "Avatar image for Kidd Cat"
  },
  {
    id: 11,
    name: "Pat Platypus",
    image: student11Svg,
    alt: "Avatar image for Pat Platypus"
  },
  {
    id: 12,
    name: "Whit Wombat",
    image: student12Svg,
    alt: "Avatar image for Whit Wombat"
  },
  {
    id: 13,
    name: "Tazzie De Ville",
    image: student13Svg,
    alt: "Avatar image for Tazzie De Ville"
  },
  {
    id: 14,
    name: "Willow Wallaby",
    image: student14Svg,
    alt: "Avatar image for Willow Wallaby"
  },
  {
    id: 15,
    name: "Cris Croc",
    image: student15Svg,
    alt: "Avatar image for Cris Croc"
  },
  {
    id: 16,
    name: "El Emu",
    image: student16Svg,
    alt: "Avatar image for El Emu"
  },
  {
    id: 17,
    name: "Kai Kookaburra",
    image: student17Svg,
    alt: "Avatar image for Kai Kookaburra"
  },
  {
    id: 18,
    name: "Euka (Burnt Yellow)",
    image: student18Svg,
    alt: "Avatar image for Euka Burnt Yellow"
  },
  {
    id: 19,
    name: "Euka (Blue)",
    image: student19Svg,
    alt: "Avatar image for Euka Blue"
  },
  {
    id: 20,
    name: "Euka (Mint)",
    image: student20Svg,
    alt: "Avatar image for Euka Mint"
  },
  {
    id: 21,
    name: "Euka (Sunshine)",
    image: student21Svg,
    alt: "Avatar image for Euka Sunshine"
  },
  {
    id: 22,
    name: "Euka (Red)",
    image: student22Svg,
    alt: "Avatar image for Euka Red"
  },
  {
    id: 23,
    name: "Euka (Lilac)",
    image: student23Svg,
    alt: "Avatar image for Euka Lilac"
  },
  {
    id: 24,
    name: "Euka (Waxflower)",
    image: student24Svg,
    alt: "Avatar image for Euka Waxflower"
  },
  {
    id: 25,
    name: "Euka (Grey)",
    image: student25Svg,
    alt: "Avatar image for Euka Grey"
  }
];
